import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice-to-cavali',
  templateUrl: './invoice-to-cavali.component.html',
  styleUrls: ['./invoice-to-cavali.component.scss']
})
export class InvoiceToCavaliComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
